<ng-container *ngIf="render$ | async" />

<div class="flex flex-col justify-center items-center" id="butt-form">
  <button
    i18n
    mat-raised-button
    color="accent"
    class="set-all-sides"
    [disabled]="!editable"
    (click)="setButtForAllSides(buttsInColorList)">
    Облицевать все
  </button>
  <div i18n *ngIf="panel.panelOutline.faceBanding.length > 0" class="total-panel-thickness">
    Толщина панели с учетом облицовки {{ fullPanelThickness }}mm
  </div>

  <!-- TOP -->
  <div class="flex flex-row justify-center items-center gap-2 mb-1">
    <ng-container *ngIf="postforming !== 1">
      <ng-container *ngIf="!panel.l1; else topElseTemplate">
        <mat-button-toggle-group
          [disabled]="!editable"
          [class.hidden]="!editable"
          #buttInColorButtonToggleTop="matButtonToggleGroup"
          aria-label=""
          [value]="panel.l1 ? panel.l1.thickness : undefined"
          (change)="setButt($event, thisByttTypeEnum.top)">
          <mat-button-toggle *ngFor="let item of buttsInColorThicknesses" [value]="item">{{ item }} </mat-button-toggle>
        </mat-button-toggle-group>
      </ng-container>
      <ng-template #topElseTemplate>
        <div class="h4">{{ panel.l1.sign }} ({{ panel.l1.thickness }}mm)</div>
      </ng-template>
    </ng-container>

    <div class="flex flex-row justify-start items-center">
      <div class="flex flex-col justify-center items-center" *ngIf="postforming !== 1 && editable">
        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="setButtFromBase(thisByttTypeEnum.top)"
          class="settings-btn">
          <mat-icon class="s-16" i18n-matTooltip matTooltip="Изменить">settings</mat-icon>
        </button>

        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="deleteButt(thisByttTypeEnum.top)"
          class="settings-btn">
          <mat-icon class="s-16" i18n-matTooltip matTooltip="Удалить">delete_outline</mat-icon>
        </button>
      </div>

      <mat-icon
        class="s-16"
        *ngIf="postforming === 1"
        [mdePopoverTriggerFor]="postformingPopover"
        mdePopoverTriggerOn="hover"
        >info_outline
      </mat-icon>
    </div>
  </div>
  <!-- / TOP -->

  <div class="flex flex-row justify-center items-center">
    <!-- LEFT -->
    <div class="flex flex-col justify-center items-center gap-2 mr-1">
      <ng-container *ngIf="!panel.w1; else leftElseTemplate">
        <mat-button-toggle-group
          [disabled]="!editable"
          [class.hidden]="!editable"
          #buttInColorButtonToggleLeft="matButtonToggleGroup"
          aria-label=""
          [vertical]="true"
          [value]="panel.w1 ? panel.w1.thickness : undefined"
          (change)="setButt($event, thisByttTypeEnum.left)">
          <mat-button-toggle *ngFor="let item of buttsInColorThicknesses" [value]="item">{{ item }} </mat-button-toggle>
        </mat-button-toggle-group>
      </ng-container>
      <ng-template #leftElseTemplate>
        <div class="h4 text-vertical">{{ panel.w1.sign }} ({{ panel.w1.thickness }}mm)</div>
      </ng-template>

      <div class="flex flex-row justify-center items-center" *ngIf="editable">
        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="setButtFromBase(thisByttTypeEnum.left)"
          class="settings-btn"
          matTooltip="Изменить">
          <mat-icon class="s-16">settings</mat-icon>
        </button>

        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="deleteButt(thisByttTypeEnum.left)"
          class="settings-btn"
          matTooltip="Удалить">
          <mat-icon class="s-16">delete_outline</mat-icon>
        </button>
      </div>
    </div>
    <!-- / LEFT -->

    <csl-svg-workspace #svgWorkspace [p]="panel" [postforming]="postforming"></csl-svg-workspace>

    <!-- RIGHT -->
    <div class="flex flex-col justify-center items-center gap-2 ml-1">
      <ng-container *ngIf="!panel.w2; else rightElseTemplate">
        <mat-button-toggle-group
          [disabled]="!editable"
          [class.hidden]="!editable"
          #buttInColorButtonToggleRight="matButtonToggleGroup"
          aria-label=""
          [vertical]="true"
          [value]="panel.w2 ? panel.w2.thickness : undefined"
          (change)="setButt($event, thisByttTypeEnum.right)">
          <mat-button-toggle *ngFor="let item of buttsInColorThicknesses" [value]="item">{{ item }} </mat-button-toggle>
        </mat-button-toggle-group>
      </ng-container>
      <ng-template #rightElseTemplate>
        <div class="h4 text-vertical">{{ panel.w2.sign }} ({{ panel.w2.thickness }}mm)</div>
      </ng-template>

      <div class="flex flex-row justify-center items-center" *ngIf="editable">
        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="setButtFromBase(thisByttTypeEnum.right)"
          class="settings-btn"
          matTooltip="Изменить">
          <mat-icon class="s-16">settings </mat-icon>
        </button>

        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="deleteButt(thisByttTypeEnum.right)"
          class="settings-btn"
          matTooltip="Удалить">
          <mat-icon class="s-16">delete_outline</mat-icon>
        </button>
      </div>
    </div>
    <!-- / RIGHT -->
  </div>

  <!-- BOTTOM -->
  <div class="flex flex-row justify-center items-center gap-2 mt-1">
    <ng-container *ngIf="postforming !== 2">
      <ng-container *ngIf="!panel.l2; else bottomElseTemplate">
        <mat-button-toggle-group
          [disabled]="!editable"
          [class.hidden]="!editable"
          #buttInColorButtonToggleBottom="matButtonToggleGroup"
          aria-label=""
          [value]="panel.l2 ? panel.l2.thickness : undefined"
          (change)="setButt($event, thisByttTypeEnum.bottom)">
          <mat-button-toggle *ngFor="let item of buttsInColorThicknesses" [value]="item">{{ item }} </mat-button-toggle>
        </mat-button-toggle-group>
      </ng-container>
      <ng-template #bottomElseTemplate>
        <div class="h4">{{ panel.l2.sign }} ({{ panel.l2.thickness }}mm)</div>
      </ng-template>
    </ng-container>

    <div class="flex flex-row justify-start items-center">
      <div class="flex flex-col justify-center items-center" *ngIf="postforming !== 2 && editable">
        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="setButtFromBase(thisByttTypeEnum.bottom)"
          class="settings-btn"
          matTooltip="Изменить">
          <mat-icon class="s-16">settings</mat-icon>
        </button>

        <button
          i18n-matTooltip
          [disabled]="!editable"
          mat-icon-button
          (click)="deleteButt(thisByttTypeEnum.bottom)"
          class="settings-btn"
          matTooltip="Удалить">
          <mat-icon class="s-16">delete_outline</mat-icon>
        </button>
      </div>

      <mat-icon
        class="s-16"
        *ngIf="postforming === 2"
        [mdePopoverTriggerFor]="postformingPopover"
        mdePopoverTriggerOn="hover"
        >info_outline
      </mat-icon>
    </div>
  </div>
  <!-- / BOTTOM -->

  <mde-popover #postformingPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
    <div class="p-4 mat-elevation-z8 fuse-white">
      <mat-icon svgIcon="postforming" class="s-128"></mat-icon>
    </div>
  </mde-popover>
</div>
